var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, ToggleButton as MuiToggleButton, Typography, styled, } from '@mui/material';
import React, { forwardRef } from 'react';
import { gray40opacity20, gray75, white } from '../../colors/gray';
import { neutral60opacity20 } from '../../colors/neutral';
import { resolveSvgIcon } from '../../utils/internalUtils';
import { rem } from '../../utils/rem';
import { isLightTheme } from '../../utils/utils';
// Constants.
// Component heights for combinations of caption and primary text sizes.
var CAPTION_SMALL = rem(36);
var CAPTION_NORMAL = rem(42);
var CAPTION_LARGE = rem(48);
// Styles.
var styles = {
    innerContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    primaryText: function (props) { return ({
        alignItems: 'center',
        display: 'flex',
        gap: rem('6px'),
        height: props.size === 'large' ? rem(22) : props.size === 'small' ? rem(12) : rem(16),
        margin: '0 auto',
    }); },
    startIcon: function (isDisabled) {
        var style = {
            fontSize: '1rem',
            height: rem(26),
        };
        // Remove/unset the color for disabled state.
        if (isDisabled) {
            style['& :first-of-type'] = { color: 'unset' };
        }
        return style;
    },
    caption: {
        color: 'text.secondary',
        height: rem(14),
    },
};
// Components.
var SMuiToggleButton = styled(MuiToggleButton, {
    name: 'MuiToggleButton',
    shouldForwardProp: function (prop) { return !['caption', 'startIcon', 'variant'].includes(prop); },
    overridesResolver: function (_a) {
        var caption = _a.caption, size = _a.size, theme = _a.theme, variant = _a.variant;
        var lightTheme = isLightTheme(theme);
        var isFramed = variant === 'framed';
        return [
            { flexShrink: 0 },
            isFramed && { borderColor: lightTheme ? neutral60opacity20 : gray40opacity20 },
            isFramed && { backgroundColor: lightTheme ? white : gray75 },
            caption && size !== 'large' && { paddingTop: 2 },
            caption && {
                height: size === 'large'
                    ? CAPTION_LARGE
                    : size === 'small'
                        ? CAPTION_SMALL
                        : CAPTION_NORMAL,
            },
        ];
    },
})({});
var ToggleButton = forwardRef(function (props, ref) { return (React.createElement(SMuiToggleButton, __assign({}, props, { ref: ref }),
    React.createElement(Box, { sx: styles.innerContent },
        React.createElement(Box, { sx: styles.primaryText(props) },
            props.startIcon && (React.createElement(Box, { sx: styles.startIcon(Boolean(props.disabled)) }, resolveSvgIcon(props.startIcon))),
            props.children),
        props.caption && (React.createElement(Typography, { variant: "caption", sx: styles.caption }, props.caption))))); });
ToggleButton.displayName = 'ToggleButton';
export default ToggleButton;
